import React from 'react'

import T from 'components/FormattedMessage'
import GameCreationScreen from 'components/GameCreationScreen'

import { RouteComponentProps } from 'react-router'
import { MatchesResponse } from 'protos'

import helpIconUrl from 'assets/images/matchselect_help_icon.svg'
import MatchesTab from './tabs/MatchesTab'

type Props = {
  getFeaturedActiveMatches: () => Promise<MatchesResponse>
  getAllActiveMatches: () => Promise<MatchesResponse>
  getContestMatches?: () => Promise<MatchesResponse>
  onMatchSelect: (matchId: string) => void
} & RouteComponentProps<{}>

type State = {
  selectedTab: number
}

class SelectMatchScreen extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { selectedTab: 0 }
  }

  onTabSelect = (tabIndex: number) => {
    this.setState({ selectedTab: tabIndex })
  }

  renderFeaturedMatches = () => {
    const { onMatchSelect, getFeaturedActiveMatches } = this.props
    return <MatchesTab showSponsored getMatchesFn={getFeaturedActiveMatches} onMatchSelect={onMatchSelect} />
  }

  renderAllMatches = () => {
    const { onMatchSelect, getAllActiveMatches } = this.props
    return <MatchesTab getMatchesFn={getAllActiveMatches} onMatchSelect={onMatchSelect} />
  }

  renderContestMatches = () => {
    const { onMatchSelect, getContestMatches } = this.props
    return <MatchesTab getMatchesFn={getContestMatches!} onMatchSelect={onMatchSelect} />
  }

  render() {
    const { selectedTab } = this.state

    return (
      <GameCreationScreen
        title={<T id="gamesetup_match_title" />}
        selectedTab={selectedTab}
        onTabSelect={this.onTabSelect}
        onBack={this.props.history.goBack}
        help={{
          title: 'gameselection_help_title',
          message: 'gameselection_help_text',
          buttonLabel: 'gameselection_help_dismiss',
          iconUrl: helpIconUrl,
        }}
        component={this.props.getContestMatches && this.renderContestMatches}
        tabs={this.props.getContestMatches ? undefined : [
          {
            title: <T id="gamesetup_match_featured" />,
            component: this.renderFeaturedMatches,
          },
          {
            title: <T id="gamesetup_match_all" />,
            component: this.renderAllMatches,
          },
        ]}
      />
    )
  }
}

export default SelectMatchScreen
